@if (
  {
    form: form$ | async,
    instance: instance$ | async,
    submitted: submitted$ | async,
  };
  as config
) {
  <app-modal-header
    [automaticClose]="false"
    (closeEvent)="onClose(config.instance)"
    class="border-b-2 border-theme-500"
  >
    <div class="flex items-center">
      <svg-icon
        class="hidden md:block"
        [ngClass]="{
          'w-24': isExternalHispanic(),
          'w-28': isExternalHispanic(),
        }"
        [src]="isExternalHispanic() ? 'assets/images/logos/logo-acesclass.svg' : 'assets/images/logos/logo-eclass.svg'"
      >
      </svg-icon>
      <hr app-modal-divider class="hidden md:block" />
      @if (!!config.instance) {
        <div class="flex items-baseline gap-2">
          <h1 class="flex text-3xl text-gray-700">{{ config.instance?.title | translate }}</h1>
          <h2 class="text-lg text-gray-500" translate>geral.cadastrar</h2>
        </div>
      }
    </div>
  </app-modal-header>
  <div app-modal-content class="w-[90vw] md:w-[90vw] p-0! xl:w-[120rem] xl:max-w-[80vw]">
    <app-sidenav-group class="h-full w-full">
      <!-- Sidenav Daily -->
      @if (!!config.instance) {
        <ng-template
          app-sidenav-start
          [opened]="true"
          panelWidth="350px"
          bgColor="bg-base-whisper-500 !shadow-inner-horizontal"
        >
          <app-sidenav-daily
            class="relative block h-full px-6"
            [startDate]="data?.date"
            [entityId]="data?.entityId"
            [groupId]="data?.groupId"
            [multiple]="!isEdit"
            [subjectId]="data?.subjectId"
            [targets]="targetsCtrl.value"
            [statusError]="showError(targetsCtrl)"
            [config]="config.instance"
            (selected)="onTargets($event)"
            (formEdit)="onTargetForm($event)"
            (selectedForm)="onSelectedForm($event)"
          ></app-sidenav-daily>
        </ng-template>
      }

      <ng-template app-sidenav-outer>
        <!-- Daily Forms -->
        <div
          class="block h-[75vh] w-full overflow-y-auto overflow-x-hidden px-6 pt-9 md:h-[calc(100vh-10rem)] xl:h-[80vh]"
        >
          @if (!!config.instance && !(targetsCtrl.value | isEmpty)) {
            <div class="flex flex-wrap items-center gap-2 pb-6">
              <span class="w-fit text-md italic text-gray-500">{{ config.instance.targetsLabel | translate }}:</span>
              @for (target of targetsCtrl.value; track target) {
                <span
                  class="h-fit rounded-full bg-theme-500 px-3 text-theme-contrast"
                  app-tooltip
                  [tooltip]="tooltip(target)"
                >
                  {{ target.group.description }}
                </span>
              }
            </div>
          }

          <ng-template [cdkPortalOutlet]="config.form.component" (attached)="onAttached($event)"></ng-template>

          <div class="mb-8 flex flex-col gap-6">
            @if (isBrazil()) {
              @let currentElements = selectedTrailElements$ | async;
              <div
                class="flex w-full flex-row items-center justify-between gap-5 border-l-4 border-modules-learning-trails-500 p-4"
                [ngClass]="
                  currentElements.length > 0
                    ? 'rounded-t-xl bg-modules-learning-trails-500'
                    : 'rounded-xl bg-modules-learning-trails-300'
                "
              >
                <div
                  class="flex h-14 w-14 flex-col items-center justify-center rounded-full bg-base-gray-light-500 shadow-inner shadow-base-gray-200"
                >
                  <svg-icon class="w-6 text-modules-learning-trails-500" src="assets/icons/icon-degree.svg"></svg-icon>
                </div>
                <div
                  translate
                  class="w-9/12 text-md"
                  [ngClass]="currentElements.length > 0 ? 'font-semibold text-white' : 'font-medium text-black'"
                >
                  eclass.importar-trilhas.quer-importar-trilha
                </div>
                <div class="relative flex w-3/12 justify-end">
                  <button
                    [ngClass]="
                      currentElements.length > 0 ? 'bg-modules-learning-trails-400' : 'bg-modules-learning-trails-500'
                    "
                    (click)="onOpenModalAddTrail(config)"
                    type="submit"
                    [disabled]="submitted$ | async"
                    app-flat-button
                    class="gap-2 rounded-2xl! px-5! text-white"
                  >
                    <ng-container>
                      <svg-icon class="flex w-6 text-white" src="assets/icons/icon-import.svg"></svg-icon>
                    </ng-container>
                    <span translate>eclass.importar-trilhas.importar-trilhas</span>
                  </button>
                </div>
              </div>
              @if (currentElements | noEmpty) {
                <div class="rounded-b-xl border border-modules-learning-trails-500 bg-gray-100 p-4">
                  <div class="grid h-auto gap-4 py-5">
                    <app-accordion>
                      <app-accordion-item>
                        <div app-accordion-header>
                          <div class="flex items-center gap-4">
                            <ng-container>
                              <svg-icon
                                class="flex w-5 text-modules-learning-trails-500"
                                src="assets/icons/icon-list.svg"
                              ></svg-icon>
                            </ng-container>
                            <span class="text-md text-modules-learning-trails-500" translate>
                              eclass.trilhas-aula
                            </span>
                          </div>
                        </div>

                        <ng-template app-accordion-lazy>
                          <div app-accordion-content class="rounded-xl bg-[#fafafa]! p-3! shadow shadow-black/20">
                            <div class="flex w-full flex-col items-end gap-2 pl-1">
                              <ng-container>
                                @for (element of currentElements; track element.id) {
                                  <div class="relative z-20 w-full">
                                    <div
                                      class="flex h-[3.25rem] w-full cursor-pointer items-center justify-between rounded-md bg-white px-5 shadow shadow-black/20"
                                    >
                                      <div class="flex gap-3">
                                        <svg-icon
                                          [ngClass]="getStyleTextIcon(element.tipo)"
                                          class="flex w-8 justify-center group-hover:text-theme-contrast"
                                          [src]="'assets/icons/' + mapTypeToIcon(element.tipo)"
                                        >
                                        </svg-icon>
                                        <h3 class="font-medium text-gray-800">
                                          {{ element.titulo }}
                                        </h3>
                                      </div>
                                      <button
                                        app-icon-button
                                        (click)="onRemoveElement(element, config)"
                                        type="button"
                                        class="ng-star-inserted cursor-pointer"
                                        aria-label="Remover"
                                      >
                                        <svg-icon
                                          class="w-5 text-modules-learning-trails-500 hover:text-modules-learning-trails-400"
                                          src="assets/icons/icon-trash-2.svg"
                                        >
                                        </svg-icon>
                                      </button>
                                    </div>
                                    <div
                                      class="absolute -left-1 top-0 -z-10 h-[3.25rem] w-3 rounded-l-md bg-[#009357]"
                                    ></div>
                                  </div>
                                }
                              </ng-container>
                            </div>
                          </div>
                        </ng-template>
                      </app-accordion-item>
                    </app-accordion>
                  </div>
                </div>
              }
            }
            <ng-container *isAllow="[20, 67]">
              <div
                class="flex w-full flex-row items-center justify-between gap-5 border-l-4 border-modules-games-500 p-4"
                [ngClass]="switchGames() ? 'rounded-t-xl bg-modules-games-500' : 'rounded-xl bg-modules-games-300'"
              >
                <div
                  class="flex h-14 w-14 flex-col items-center justify-center rounded-full bg-base-gray-light-500 shadow-inner shadow-base-gray-200"
                >
                  <svg-icon class="w-6 text-modules-games-500" src="assets/icons/icon-dice.svg"></svg-icon>
                </div>
                <div
                  class="w-9/12 text-md"
                  [ngClass]="switchGames() ? 'font-semibold text-white' : 'font-medium text-black'"
                  translate
                >
                  eclass.importar-jogos.pergunta
                </div>
                <div class="flex w-3/12 justify-end">
                  <app-switch (changeStatus)="onClickSwitch($event, 'games')" [checked]="switchGames()"></app-switch>
                </div>
              </div>
              <div
                class="flex flex-row gap-8 rounded-b-xl border border-modules-games-500 bg-gray-100 p-4"
                [ngClass]="switchGames() ? 'block' : 'hidden'"
              >
                <div [formGroup]="gamesForm" class="w-1/3">
                  <app-form-field class="w-full">
                    <label app-label translate>eclass.importar-jogos.serie</label>
                    <ng-select
                      app-select
                      formControlName="serie"
                      [placeholder]="'eclass.importar-jogos.selecione-serie' | translate"
                      bindLabel="descricao"
                      bindValue="id"
                      [items]="gameSeries()"
                      [loading]="!!loadingGameSeries()"
                    ></ng-select>
                  </app-form-field>
                  <app-form-field class="w-full">
                    <label app-label translate>eclass.importar-jogos.disciplina</label>
                    <ng-select
                      app-select
                      formControlName="discipline"
                      [placeholder]="'eclass.importar-jogos.selecione-disciplina' | translate"
                      bindLabel="descricao"
                      bindValue="id"
                      [items]="gameDisciplines()"
                      [loading]="!!loadingGameDisciplines()"
                    ></ng-select>
                  </app-form-field>
                </div>
                <div class="w-2/3">
                  <label app-label translate>eclass.importar-jogos.selecione-jogo</label>
                  <div
                    class="flex h-80 flex-col gap-4 overflow-auto rounded-xl border border-modules-games-500 bg-white p-6"
                  >
                    @if (!!loadingGames()) {
                      <app-skeleton></app-skeleton>
                    } @else {
                      @if (games() | noEmpty) {
                        @for (game of games(); track game.id) {
                          <div class="flex flex-row items-center gap-4">
                            <div class="block w-auto">
                              <input
                                type="checkbox"
                                [checked]="isGameChecked(game.id)"
                                (click)="onCheckGame($event, config, game.id)"
                                class="h-7 w-7 cursor-pointer rounded-full text-modules-games-700"
                              />
                            </div>
                            <div class="w-full">
                              <app-card
                                class="flex flex-row! items-center rounded-2xl! bg-modules-games-300! shadow-black/25! transition duration-300"
                              >
                                <div app-card-content class="flex w-full items-center justify-between gap-4 p-3!">
                                  <div class="flex justify-start">
                                    <a
                                      app-icon-button
                                      class="w-fit overflow-hidden rounded-full! bg-white! p-3 shadow-inner shadow-black/40 brightness-100!"
                                    >
                                      <svg-icon
                                        class="flex h-6 w-6 transition duration-300"
                                        src="assets/icons/icon-botoes-controle.svg"
                                      ></svg-icon>
                                    </a>
                                  </div>
                                  <div class="grid w-full">
                                    <strong class="truncate">{{ game.topic }}</strong>
                                    <span>{{ game.name }}</span>
                                  </div>
                                  <svg-icon
                                    class="flex w-8 cursor-pointer text-modules-games-700 transition duration-300 hover:scale-125"
                                    (click)="onOpenGame(game)"
                                    src="assets/icons/icon-eyes.svg"
                                  ></svg-icon>
                                </div>
                              </app-card>
                            </div>
                          </div>
                        }
                      } @else {
                        <app-jumbotron translate>eclass.importar-jogos.vazio</app-jumbotron>
                      }
                    }
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
      <!-- Sidenav Evaluation -->
      @if (!!config?.instance?.showSidenavEnd) {
        <ng-template
          app-sidenav-end
          [opened]="true"
          panelWidth="250px"
          bgColor="bg-base-whisper-300 shadow-inner-horizontal!"
        >
          <app-sidenav-evaluation
            class="relative block h-full px-6"
            [targets]="targetsCtrl.value"
            [formGroup]="config.instance.form"
          ></app-sidenav-evaluation>
        </ng-template>
      }
      <!-- @if (isEdit && !!config?.instance?.showSidenavDaily) {
        <ng-template
          app-sidenav-end
          [opened]="true"
          panelWidth="300px"
          bgColor="bg-modules-sequence-100 shadow-inner-horizontal!"
        >
          <app-sidenav-sequence class="relative block h-full px-4"> </app-sidenav-sequence>
        </ng-template>
      } -->
    </app-sidenav-group>
  </div>
  @if (!!config?.instance) {
    <div app-modal-footer class="flex-col-reverse items-end justify-between gap-2 md:flex-row">
      <button
        app-outline-button
        class="h-fit w-48 border-theme-500 uppercase text-theme-500 hover:bg-theme-500 hover:text-theme-contrast"
        type="button"
        (click)="onClose(config.instance)"
      >
        {{ 'geral.cancelar' | translate }}
      </button>
      <div class="flex w-full justify-between gap-6 md:w-fit">
        <div class="flex items-center gap-2">
          <app-switch colorTrue="bg-theme-300" [formControl]="publishCtrl"></app-switch>
          {{ config.instance.publishLabel | translate }}
        </div>
        <button
          app-icon-button
          type="button"
          [disabled]="config.submitted"
          (click)="onSave(config)"
          class="w-48 gap-3 bg-theme-500 uppercase text-theme-contrast"
        >
          @if (config.submitted) {
            <app-skeleton class="h-5! w-5!" baseStyle="bg-theme-500" [showLabel]="false"></app-skeleton>
          } @else {
            <svg-icon class="flex h-5 w-5 text-white" src="assets/icons/icon-plus.svg"></svg-icon>
          }
          {{ 'geral.salvar' | translate }}
        </button>
      </div>
    </div>
  }
}
